import { render, staticRenderFns } from "./TheObserver.vue?vue&type=template&id=5cbb5a86"
import script from "./TheObserver.vue?vue&type=script&lang=js"
export * from "./TheObserver.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports